import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export interface StudentSummaryResponse {
  fast_phonics_student_summary: {
    students: StudentData[]
  }
}

interface StudentData {
  student_id: number
  lessons: {
    initial_lesson: number
    highest_lesson: Nullable<number>
    total_lessons: number
    mastered_lessons: number
    recent_activity: {
      created_at: number
      lesson: number
      score: number
    }[]
    placement_tests: {
      created_at: number
      lesson: number
      skipped_test: boolean
    }[]
  }
  assignments: {
    recent_activity: {
      created_at: number
      lesson: number
      score: number
    }[]
  }
  assessments: {
    quizzes_taken: number
    attempts: number
    average_score: number
    recent_activity: {
      created_at: number
      lesson: number
      score: number
    }[]
  }
  books: {
    books_read: number
    words_read: number
    book_quizzes_attempted: number
    recent_activity: {
      created_at: number
      book_code: string
      book_name: string
    }[]
  }
  areas_of_weakness: {
    recent_activity: {
      created_at: number
      lesson: number
      score: number
    }[]
  }
  peaks_progress: {
    books_read: number
    book_quizzes_attempted: number
    sound_gems_earned: number
    word_gems_earned: number
  }
}

export type StudentSummaryData = StudentData

export async function studentSummary(
  this: StudentEventsService,
  product: LegacyProductFp,
  statsScope: StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<StudentSummaryData>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('student_summary', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<StudentSummaryResponse>(url, query)
  if (!data) return null

  const {
    fast_phonics_student_summary: { students },
  } = data
  if (students.length === 0) return null

  return students[0]
}
